module.exports = __webpack_public_path__ + "static/media/ubud-monkeys.3c07f1b3.jpg";